import { render, staticRenderFns } from "./CardViewSelector.vue?vue&type=template&id=125e84ec&scoped=true"
import script from "./CardViewSelector.vue?vue&type=script&lang=js"
export * from "./CardViewSelector.vue?vue&type=script&lang=js"
import style0 from "./CardViewSelector.vue?vue&type=style&index=0&id=125e84ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125e84ec",
  null
  
)

export default component.exports